<div class="item-weight-unit">
    <div class="unit-content">
        <span class="title">{{ title }}</span>
        <div class="unit-content-value">
            <span class="unit-value">{{ currentValue || 0 }} {{ unit }}</span>
            <img *ngIf="currentValue > 0"
                 [src]="isExceeded ? './assets/images/bags/unit-warning.svg' : './assets/images/bags/unit-success.svg'"
                 alt="">
        </div>
    </div>

    <div class="unit-content unit-content--right" *ngIf="isExceeded">
        <span class="badge-warning">{{ exceededBadgeText }}</span>
        <span class="unit-value">+{{ difference || 0 }} {{ unit }}</span>
    </div>

    <div class="unit-content unit-content--right">
        <span class="title">{{ maxLabel }}</span>
        <span class="unit-value unit-value--max">{{ maxValue }} {{ unit }}</span>
    </div>
</div>
